import { Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'eui-app-footer',
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ['./_styles/_index.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class EuiAppFooterComponent {

    @HostBinding() class = 'eui-app-footer';
    @HostBinding('attr.role') role = 'contentinfo';

    constructor() {
    }
}
